import { type FC, type ReactNode, useEffect } from 'react';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  width?: string;
  footer?: ReactNode;
}

const Drawer: FC<DrawerProps> = ({ isOpen, onClose, title, children, width = 'w-[480px]', footer }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 z-50">
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
          <div className={`absolute right-0 top-0 h-full ${width} bg-background-50 border-l border-background-200 flex flex-col transform transition-transform duration-300`}>
            <div className="flex items-center justify-between px-6 py-4 border-b border-background-200">
              <h3 className="text-lg font-semibold text-foreground-900">{title}</h3>
              <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center text-foreground-400 hover:text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            <div className="flex-1 overflow-y-auto px-6 py-4">
              {children}
            </div>
            {footer && (
              <div className="px-6 py-4 border-t border-background-200 flex items-center justify-end gap-3">
                {footer}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Drawer;